import i18n from "@/store/i18n"

export const productInterval = (interval) => {
  switch(interval){
    case "day":
      return i18n.t('lib.productInterval.day')
    case "week":
      return i18n.t('lib.productInterval.week')
    case "month":
      return i18n.t('lib.productInterval.month')
    case "year":
      return i18n.t('lib.productInterval.year')
    default:
      return interval
  }
}
